import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from '@travellegacy/nexops-design-system';
import { CheckCircle2, MessageCircle } from 'lucide-react';

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('payment_id');
  const status = searchParams.get('status');
  const linkType = searchParams.get('linkType');

  const shouldShowOnboarding = linkType === 'SERVICO';

  useEffect(() => {
    // Log para analytics/tracking
    console.log('Payment Success:', { paymentId, status, linkType });

    // Limpar o link do Mercado Pago do localStorage após sucesso
    localStorage.removeItem('mercadopago_init_point');
  }, [paymentId, status, linkType]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FAF7F2] to-[#DED1BD]/30 dark:from-[#0f0606] dark:to-[#240404] flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-xl">
        <CardHeader className="text-center pb-6">
          <div className="mx-auto mb-4 w-20 h-20 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center">
            <CheckCircle2 className="h-12 w-12 text-green-600 dark:text-green-400" />
          </div>
          <CardTitle className="text-2xl font-bold text-green-900 dark:text-green-100">
            Pagamento Aprovado!
          </CardTitle>
          <CardDescription className="text-base mt-2">
            Seu pagamento foi processado com sucesso
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-6">
          {paymentId && (
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
              <p className="text-xs text-gray-600 dark:text-gray-400 mb-1">ID do Pagamento</p>
              <p className="text-sm font-mono font-medium text-gray-900 dark:text-gray-100">
                {paymentId}
              </p>
            </div>
          )}

          {shouldShowOnboarding && (
            <div className="bg-[#DED1BD]/30 dark:bg-[#B05D41]/10 border border-[#B05D41]/30 dark:border-[#B05D41]/30 rounded-lg p-4">
              <div className="flex gap-3">
                <MessageCircle className="h-5 w-5 text-[#B05D41] dark:text-[#B05D41] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-medium text-[#240404] dark:text-[#DED1BD] mb-1">
                    Próximos Passos
                  </p>
                  <p className="text-sm text-[#240404]/80 dark:text-[#DED1BD]/80">
                    Em breve você receberá uma mensagem no WhatsApp para iniciarmos o processo de
                    onboarding.
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
            <p className="text-xs text-center text-gray-600 dark:text-gray-400">
              Obrigado por escolher a Travel Legacy!
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
